import { Button } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';

const ClearButton: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleClearFilters = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete('keyword');
    searchParams.delete('location');
    navigate(`${location.pathname}`);
    // window.location.reload()
  };

  return (
    <Button color='error' onClick={handleClearFilters} variant='contained'>Clear filter</Button>
  );
};

export default ClearButton;
